import { useIntl } from 'react-intl'

import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
  isFulfillmentListing,
} from '@b-stock/fe-core/bstock-next/queries'
import { Accordion } from '@b-stock/fe-core/bstock-react'

import { MobileAccordionWrapper } from '../ListingDetailsLayout/ui'
import { ShipmentInformation } from './ShipmentInformation'

export const ListingShipmentSection = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const { formatMessage } = useIntl()
  const hazmatOnly =
    listing.listingType === 'CONTRACT' && listing.shipping?.hazmat?.isHazardous

  if (
    !isFulfillmentListing(listing) &&
    listing.listingType !== 'SPOT' &&
    !hazmatOnly
  ) {
    return null
  }

  return (
    <MobileAccordionWrapper>
      <Accordion
        label={formatMessage({ id: 'Auction.title.shipmentInformation' })}
        isOpen
      >
        <ShipmentInformation listing={listing} hazmatOnly={hazmatOnly} />
      </Accordion>
    </MobileAccordionWrapper>
  )
}
